import React, { useState } from "react";
import chat from "../../resources/images/chat.png";
import { setShowChat, setShowPopUsers } from "../../store/actions";
import { connect } from "react-redux";
import { Tooltip } from "react-tooltip";
import PopupMessages from "../ChatSection/PopupMessages";
import store from "../../store/store";

const ChatButton = (props) => {
  const { setShowChatAction, showChat, setShowPopUsersAction } = props;

  const handleMenuButtonPressed = () => {
    setShowPopUsersAction(false);
    setShowChatAction(!showChat);
  };
  
  return (
    <>
      <div className="video_button_container">
        <div className="icon-container">
          {store.getState().messages.length > 0 && (
            <div className="blue-circle"></div>
          )}
          <Tooltip id="tooltip-chat" />
          <div
            className="video_button_image"
            onClick={handleMenuButtonPressed}
            data-tooltip-id="tooltip-chat"
            data-tooltip-content="Chat"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 0,
            }}
          >
            <img
              src={chat}
              alt="Chat"
              style={{
                width: '24px',
                height: '24px',
                objectFit: 'contain',
                filter: 'brightness(0) invert(1)', 
              }}
            />
          </div>
        </div>
      </div>

      {showChat && <PopupMessages />}
    </>
  );
};

const mapStoreStateToProps = (state) => {
  return {
    ...state,
  };
};

const mapActionsToProps = (dispatch) => {
  return {
    setShowChatAction: (showChat) => dispatch(setShowChat(showChat)),
    setShowPopUsersAction: (showPopUsers) =>
      dispatch(setShowPopUsers(showPopUsers)),
  };
};

export default connect(mapStoreStateToProps, mapActionsToProps)(ChatButton);
